import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ListingsService } from '../../services/listings.service';
import { Listing } from '../../classes/listing';
import { environment } from '../../../environments/environment-wrapper';

@Component({
  selector: 'app-print-listing-page',
  templateUrl: './print-listing-page.component.html',
  styleUrls: ['./print-listing-page.component.scss']
})

export class PrintListingPageComponent implements OnInit {
  filteredDetails = [];
  // Never display these details
  detailBlackList = [
    "details.listing-date", "Type", "details.mls-num", "Sqft Source", // Key Facts
    // Inside
    // Outside
    "details.last-updated", // Details
    // Utilities
    // Features
  ];
  // Display these details even if their values are null
  detailWhiteList = [
    "details.ownership-type", "details.approx-age", "propertydetails.sqft", "details.occupancy", // Key Facts
    "details.heating", "details.heating-source", "details.baths-full", "details.baths-half", "details.stories", "details.air-conditioning", "details.cooling", "details.fireplace", // Inside
    "Parking", "details.garage", "details.exterior", "details.foundation", "details.roof", "Construction Type", // Outside
    "details.property-type", "details.property-tax", "Community", // Details
    // Utilities
    "Features", "Community Features", // Features
  ];
  listing: Listing;
  serverUrl: string;

  constructor(
        private _activatedRoute: ActivatedRoute,
        private _listingsService: ListingsService
  ) { }

  ngOnInit() {
    this.serverUrl = environment.cdnServerUrl.slice(0, -1);
    this._listingsService.getListingDetails(this._activatedRoute.snapshot.params.listingId).then(
      (data) => {
        this._listingsService.populateListingRowInfo(data);
        this.listing = data;

        // Conditionally add details
        if (this.listing.isCondo) {
          this.detailWhiteList.push("details.fees");
          this.detailWhiteList.push("Fee Includes");
        }
        else {
          this.detailBlackList.push("details.fees");
          this.detailBlackList.push("Fee Includes");          
        }
        if (this.listing.fireplace == null) {
          this.detailBlackList.push("details.fireplaces");
        }
        if (this.listing.sqFtRaw != null) {
          this.detailBlackList.push("Sq Ft Range");
        }
        
        // Filter out any missing/irrelevant details from each list 
        this.filteredDetails.push(this.processDetailTbl(this.listing.keyFactRows));
        this.filteredDetails.push(this.processDetailTbl(this.listing.insideRows));
        this.filteredDetails.push(this.processDetailTbl(this.listing.outsideRows));
        this.filteredDetails.push(this.processDetailTbl(this.listing.highLevelDetailRows));
        this.filteredDetails.push(this.processDetailTbl(this.listing.utilityRows));
        this.filteredDetails.push(this.processDetailTbl(this.listing.additionalFeatureRows));
      } 
    );
    window.setTimeout(() => {
      if (document.queryCommandSupported('print')) {
        document.execCommand('print');
      }
      else {
        window.print();
      }
    }, 1500);
  }

  processDetailTbl(detailList) {
    return detailList.filter((detail) => {
      if (!this.detailBlackList.includes(detail.title) 
        && (detail.value != null || this.detailWhiteList.includes(detail.title))) {
        return detail;
      }
    });
  }
}
